var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("form", { on: { submit: _setup.onSubmitHandler } }, [
      _c(
        "div",
        { staticClass: "form" },
        [
          _c("v-text-field", {
            attrs: {
              loading: _setup.fetchingEditForm,
              "error-messages": _setup.formState.errors.title,
              "hide-details": "auto",
              outlined: "",
              dense: "",
              label: "Title"
            },
            model: {
              value: _setup.formState.data.title,
              callback: function($$v) {
                _vm.$set(_setup.formState.data, "title", $$v)
              },
              expression: "formState.data.title"
            }
          }),
          _c("v-text-field", {
            attrs: {
              loading: _setup.fetchingEditForm,
              "error-messages": _setup.formState.errors.formNo,
              "hide-details": "auto",
              outlined: "",
              dense: "",
              label: "Form No"
            },
            model: {
              value: _setup.formState.data.formNo,
              callback: function($$v) {
                _vm.$set(_setup.formState.data, "formNo", $$v)
              },
              expression: "formState.data.formNo"
            }
          }),
          _c("v-autocomplete", {
            attrs: {
              "error-messages": _setup.formState.errors.equipment,
              items: ["elevator", "escalator"],
              "hide-details": "auto",
              outlined: "",
              dense: "",
              label: "Equipment"
            },
            model: {
              value: _setup.formState.data.equipment,
              callback: function($$v) {
                _vm.$set(_setup.formState.data, "equipment", $$v)
              },
              expression: "formState.data.equipment"
            }
          }),
          _setup.props.editId
            ? _c(
                "div",
                { staticClass: "form-edit-actions" },
                [
                  _c("v-btn", { attrs: { type: "submit", color: "warning" } }, [
                    _vm._v("Update")
                  ]),
                  _c(
                    "v-btn",
                    {
                      attrs: { type: "button", color: "error" },
                      on: { click: _setup.onCancelHandler }
                    },
                    [_vm._v("Cancel")]
                  )
                ],
                1
              )
            : _c(
                "v-btn",
                {
                  attrs: {
                    type: "submit",
                    loading: _setup.formState.isLoading,
                    color: "primary",
                    dark: ""
                  }
                },
                [_vm._v("Submit")]
              )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }